import styled from 'styled-components';
import { CarGalleryStyled } from '../CarGalleryStyled';
import { rem } from 'polished';

export const CarGalleryStyledOV = styled(CarGalleryStyled)`
    .button-wrapper {
        button {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
            line-height: ${({ theme }) => theme.lineHeights.h4};
            color: ${({ theme }) => theme.colors.black2};
            padding: 0 ${rem(10)} calc(${rem(10)} + 1px) ${rem(10)};
            border-bottom: 1px solid ${({ theme }) => theme.colors.grey18};
            margin-bottom: 1px;

            &.active {
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                color: ${({ theme }) => theme.colors.black2};
                cursor: default;
                border-bottom: ${rem(3)} solid ${({ theme }) => theme.colors.black2};
                opacity: 1;
                padding-bottom: ${rem(10)};
                margin-bottom: 0;
            }

            &:first-child {
                margin-right: 0;
            }
        }
    }

    .react-multi-carousel-dot {
        button {
            width: ${rem(40)};
            height: ${rem(3)};
            margin: ${rem(8)} ${rem(4)};
            background-color: ${({ theme }) => theme.colors.grey18};
            border-radius: 0;
        }

        &--active button {
            background-color: ${({ theme }) => theme.colors.black2};
        }
    }
`;
